import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import GlgInlineLoadingSpinner from '../../../../shared/components/glg_loading_spinner_inline'
import {
  useGetWizardUnmatchedTeesQuery,
  useGetScorecentreWizardUnmatchedTeesQuery,
} from '../../../api/courses'

export const Step4AdditionalTees = ({
  source,
  existingCourseId,
  unmatchedTeeIds,
  additionalTeeIds,
  onAdditionalTeeToggle,
}) => {
  const queryParams = unmatchedTeeIds?.length > 0
    ? { unmatched_tees_ids: unmatchedTeeIds }
    : { existing_course_id: existingCourseId }

  const skip = !existingCourseId

  const { data: crsData, isLoading: crsLoading } = useGetWizardUnmatchedTeesQuery(
    queryParams,
    { skip: source !== 'crs' || skip }
  )
  const { data: scorecentreData, isLoading: scorecentreLoading } = useGetScorecentreWizardUnmatchedTeesQuery(
    queryParams,
    { skip: source !== 'scorecentre' || skip }
  )

  const data = source === 'crs' ? crsData : scorecentreData
  const isLoading = source === 'crs' ? crsLoading : scorecentreLoading

  useEffect(() => {
    if (!data?.additional_tees?.length) return
    data.additional_tees.forEach((tee) => onAdditionalTeeToggle(tee.id, true))
  }, [data])

  if (isLoading) {
    return (
      <div className="text-center add-margin-top-20">
        <GlgInlineLoadingSpinner show={true} />
      </div>
    )
  }

  if (!data) return null

  const { additional_tees } = data

  if (!additional_tees?.length) {
    return (
      <p className="text-center">
        {window.I18n.t('courses.crs.wizard_page_4.no_additional_tees')}
      </p>
    )
  }

  const handleCheckAll = () => {
    additional_tees.forEach((tee) => {
      if (!additionalTeeIds.includes(tee.id)) onAdditionalTeeToggle(tee.id, true)
    })
  }

  const handleUncheckAll = () => {
    additional_tees.forEach((tee) => onAdditionalTeeToggle(tee.id, false))
  }

  return (
    <div>
      <div className="courses-modal-dropdown-label add-margin-top-10">
        {window.I18n.t(`courses.${source}.popup.copy_additional_tees`)}
      </div>
      <div className="btsp_square_solid customer_box">
        {additional_tees.map((tee) => (
          <div key={tee.id} className="fieldset inline check">
            <label className="btsp_icheck_label no-padding-left">
              <div className={`icheckbox_square-orange btsp-icheck-xs icheck-item icheck ${additionalTeeIds.includes(tee.id) ? 'checked' : ''}`}>
                <input type="checkbox" className="icheck-input" checked={additionalTeeIds.includes(tee.id)} onChange={(e) => onAdditionalTeeToggle(tee.id, e.target.checked)} />
              </div>
              <span>{tee.name}</span>
            </label>
          </div>
        ))}
        <div className="fieldset inline check add-margin-top-10">
          <span className="courses-check-all-link" onClick={handleCheckAll}>
            {window.I18n.t('buttons.check_all')}
          </span>
          {' / '}
          <span className="courses-check-all-link" onClick={handleUncheckAll}>
            {window.I18n.t('buttons.uncheck_all')}
          </span>
        </div>
      </div>
    </div>

  )
}

Step4AdditionalTees.propTypes = {
  source: PropTypes.oneOf(['crs', 'scorecentre']).isRequired,
  existingCourseId: PropTypes.string,
  unmatchedTeeIds: PropTypes.arrayOf(PropTypes.string),
  additionalTeeIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  onAdditionalTeeToggle: PropTypes.func.isRequired,
}

Step4AdditionalTees.defaultProps = {
  unmatchedTeeIds: [],
}
